
import TicaModalTemplate from '@marketplace/components/modals/parts/tica-modal-template.vue'
import { trackClick } from '@marketplace/helpers/segment/index.js'
import { EventBus } from '@marketplace/plugins/event-bus.js'

export default {
    name: 'ModalTicaConnect',

    components: { TicaModalTemplate },

    computed: {
        usps() {
            return [
                this.$t('labels.tica_connect_modal.ups1'),
                this.$t('labels.tica_connect_modal.usp2'),
                this.$t('labels.tica_connect_modal.usp3'),
                this.$t('labels.tica_connect_modal.usp4'),
            ]
        },
    },

    mounted() {
        trackClick(
            `Opened Tica Connect Modal`,
            {
                category: 'General',
            },
            ''
        )
    },

    methods: {
        setCookieAndClose(type = null) {
            const options = {
                learn: {
                    url: '/tica',
                    event: 'Learn More on Tica Connect Modal',
                },
                connect: {
                    url: '/account/tica',
                    event: 'Connect Now on Tica Connect Modal',
                },
            }

            EventBus.$emit('modal-close', 'modal-tica-connect')

            if (type) {
                trackClick(options[type].event, {
                    category: 'General',
                })
                window.location.href = this.localeUrl(options[type].url)
            }
        },
    },
}
